var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import NumberInput from '@declaration/components/NumberInput.vue';
import LengthInput from '@declaration/components/LengthInput.vue';
import { GLASS_DAMAGE_TYPE_IMAGE_CHOICES, GLASS_DAMAGE_TYPE_PLAIN_CHOICES, } from '@declaration/constants/glassDamageConstants';
const glassDamage = namespace('glassDamage');
let PanesDescriptionComponent = class PanesDescriptionComponent extends Vue {
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get glassDamage() {
        return this.change.data;
    }
    get glassDamageTypeImageChoices() {
        return GLASS_DAMAGE_TYPE_IMAGE_CHOICES;
    }
    get glassDamageTypeButtonChoices() {
        return GLASS_DAMAGE_TYPE_PLAIN_CHOICES;
    }
    onNumberOfPanesChange(numberOfPanes) {
        this.updateGlassDamage({
            changeKey: this.changeKey,
            data: { numberOfPanes },
        });
    }
    onWidestPaneWidthChange(widestPaneWidth) {
        this.updateGlassDamage({
            changeKey: this.changeKey,
            data: { widestPaneWidth },
        });
    }
    onWidestPaneHeightChange(widestPaneHeight) {
        this.updateGlassDamage({
            changeKey: this.changeKey,
            data: { widestPaneHeight },
        });
    }
};
__decorate([
    glassDamage.Getter('change')
], PanesDescriptionComponent.prototype, "changeGetter", void 0);
__decorate([
    glassDamage.Getter('validation')
], PanesDescriptionComponent.prototype, "validationGetter", void 0);
__decorate([
    glassDamage.Action('updateDamage')
], PanesDescriptionComponent.prototype, "updateGlassDamage", void 0);
PanesDescriptionComponent = __decorate([
    Component({
        components: {
            NumberInput,
            LengthInput,
        },
        props: {
            changeKey: { type: [Number, String], default: null },
        },
    })
], PanesDescriptionComponent);
export default PanesDescriptionComponent;
